// valid each segment of the message
const generateMsg = (payload) => (payload.every(p => !!p) ? payload.join(' ') : '');
const getInventoryStatusWarningMessage = (trims, trimsInventoryStatus) => {
    if (!trimsInventoryStatus)
        return '';
    const lowInventoryTransmissions = trimsInventoryStatus.filter(s => (s === null || s === void 0 ? void 0 : s.inventoryStatus) === 'lowInventory');
    const messages = lowInventoryTransmissions.reduce((acc, cur) => {
        var _a, _b;
        const trim = trims === null || trims === void 0 ? void 0 : trims.find(t => (t === null || t === void 0 ? void 0 : t.trimKey) === (cur === null || cur === void 0 ? void 0 : cur.trimKey));
        const transmissionName = (_b = (_a = trim === null || trim === void 0 ? void 0 : trim.transmissions) === null || _a === void 0 ? void 0 : _a.find(t => (t === null || t === void 0 ? void 0 : t.transmissionKey) === (cur === null || cur === void 0 ? void 0 : cur.transmissionKey))) === null || _b === void 0 ? void 0 : _b.transmissionName;
        const message = generateMsg([trim === null || trim === void 0 ? void 0 : trim.modelYear, trim === null || trim === void 0 ? void 0 : trim.trimName, transmissionName]);
        if (message) {
            acc.push(message);
        }
        return acc;
    }, []);
    return messages.join(' & ');
};
export default getInventoryStatusWarningMessage;
